export enum StaticData {
    TEMPERATURE = 'temperature',
    PRIVACY_POLICY = 'privacy_policy',
}
